import { Fragment } from 'react'
import StoryblokEditableComment from './storyblok/StoryblokEditableComment';

const WorkHeader = ({ component }) => {
  let tags = typeof component.project.tags === 'string' ? component.project.tags.split(', ') : component.project.tags

  return (
    <>
      {' '} {component.project._editable && <StoryblokEditableComment text={component.project._editable} />}
      <header className="g-row mb-100 component component--visible">
        <p
          className="mb-200"
          dangerouslySetInnerHTML={{ __html: `${component.project.description}` }}
        />
        <h1 className="t-mega project-title">{component.project.title}</h1>
        <p className="c-purple">
          {component.project.tagline} <span className="u-dot-del">·</span>{' '}
          <span className="f-italic">
            {component.project &&
              tags.map((tag, index) => {
                return index < tags.length - 1 ? (
                  <React.Fragment key={tag}>
                    {tag} <span className="u-dot-del">·</span>
                  </React.Fragment>
                ) : (
                  <React.Fragment key={tag}> {tag}</React.Fragment>
                );
              })}
          </span>
        </p>
      </header>
    </>
  );
};

export default WorkHeader;
